import * as React from "react";
import { ReactNode } from "react";
import {
  Heading,
  Stack,
  IconButton,
  Link,
  Image,
  Box,
  Text,
  useColorModeValue,
  Flex,
  Container,
  SimpleGrid,
  Input,
  Button,
  HStack,
  Center,
  Icon,
  css
} from "@chakra-ui/react";
import siteConfig from "configs/site-config";
import UserIcon from "assets/images/hv.png";
import DiscoverAmerica from "assets/images/discover-america-white.svg";
import Dmap from "assets/images/dmap-seal-white.svg";
import Pa from "assets/images/pennsylvania-white.svg";
import { FaLinkedin, FaTwitterSquare, FaYoutubeSquare, FaFacebookSquare, FaInstagramSquare, FaSync, FaArrowCircleUp } from "react-icons/fa";

import { useState, useEffect } from "react";
import axios from "axios";
import { apiHost, baseUrl } from "utils/Cons/Constants";

const iconProps = {
  variant: "ghost",
  size: "lg",
  isRound: true
};


const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={'500'} fontSize={'lg'} mb={2}>
      {children}
    </Text>
  );
};

const Footer = () => {
  const [footerLinks1, setFooterLinks1] = useState<any[]>([]);
  const [footerLinks2, setFooterLinks2] = useState<any[]>([]);
  const [variables, setVariables] = useState<Record<string, any>>({});
  const year = (new Date()).getFullYear();
  const [isVisible, setIsVisible] = useState(false);

  const getMenu1 = () => {
    let data: any[] = [];
    axios.get(`${apiHost}/nav/get/footer_menu_1`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          setFooterLinks1(data);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const getMenu2 = () => {
    let data: any[] = [];
    axios.get(`${apiHost}/nav/get/footer_menu_2`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          setFooterLinks2(data);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const getVariables = () => {
    let data = [];
    axios.get(`${apiHost}/variables/get/global`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          setVariables(data);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  useEffect(() => {
    getMenu1();
    getMenu2();
    getVariables();
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.scrollY || window.pageYOffset;
      // Add buffer zone to prevent jittery behavior
      const showThreshold = 1400;
      const hideThreshold = 1350; // 50px buffer below show threshold
      
      if (scrollTop > showThreshold) {
        setIsVisible(true);
      } else if (scrollTop < hideThreshold) {
        setIsVisible(false);
      }
      // If between thresholds, keep current state to prevent rapid toggling
    };

    // Initial check
    toggleVisibility();
    
    // Use passive event listener for better performance
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <Box bg={'#D51F0C'} color={'white'} className="footer" css={css({"@media print": { display: "none" }})}>
      <Container as={Stack} maxW={'6xl'} pt={20} pb={10}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
          <Box>
            <SimpleGrid columns={2} spacing={8}>
              <Box className="footer-link-wrapper">
                {footerLinks1.map((link, index) => (
                  <Link
                    key={`fl1-${index}`}
                    href={link.entry.url}
                  >{link.title}</Link>
                ))}
              </Box>
              <Box className="footer-link-wrapper">
                {footerLinks2.map((link, index) => (
                  <Link
                    key={`fl2-${index}`}
                    href={link.entry.url}
                  >{link.title}</Link>
                ))}
              </Box>
            </SimpleGrid>
          </Box>
          <Box ml={{ base: 0, md: 200 }}>
            <Text className="footer-subhead connect" textTransform="uppercase">Connect with us!</Text>
            <HStack spacing={4} mt={1} mb={1} justifyContent={{ base: "center", md: "left" }}>
              <Link _hover={{ color: "#143B49" }} href={variables.facebook_link} target="_blank">
                <Icon as={FaFacebookSquare} fontSize="5xl" />
              </Link>
              <Link _hover={{ color: "#143B49" }} href={variables.instagram_link} target="_blank">
                <Icon as={FaInstagramSquare} fontSize="5xl" />
              </Link>
            </HStack>
            <Box display="flex" flexDirection="row" alignItems={{ base: "center", md: "left" }} justifyContent={{ base: "center", md: "left" }} gap={4}>
              <Link href={variables.marketing_link} target="_blank" textAlign="right">
                <Image src={Dmap} width="50px" margin="auto" mt={7} alt={'image'} />
              </Link>
              <Link href={variables.discover_america_link} target="_blank">
                <Image src={DiscoverAmerica} width="150px" margin="auto" mt={7} alt={'image'} />
              </Link>
            </Box>
            <Box display="flex" flexDirection="row" alignItems={{ base: "center", md: "left" }} justifyContent={{ base: "center", md: "left" }} gap={4}>
              <Link href={variables.pa_link} target="_blank">
                <Image src={Pa} width="160px" margin="auto" mt={7} alt={'image'} />
              </Link>
              <Link href={variables.hv_link} target="_blank">
                <Image src={UserIcon} width="50px" margin="auto" mt={7} alt={'image'} />
              </Link>
            </Box>
          </Box>
        </SimpleGrid>
å
        <Box textAlign="center">
          {isVisible && (
              <Box
                sx={{
                  opacity: isVisible ? 1 : 0,
                  visibility: isVisible ? 'visible' : 'hidden',
                  position: 'fixed',
                  bottom: '50px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  transition: 'all 0.3s ease-in-out',
                  '@media (max-width: 48em)': {
                    bottom: '70px',
                    right: '20px',
                  },
                  zIndex: 1200,
                }}
                padding="5px 15px"
                bg="#FBEEC8" 
                color="#17325B"
                borderRadius={30}
                _hover={{ bg: "#E6DFD3" }}
              >
                <Link 
                  onClick={() => window.scrollTo({top: 0, left: 0, behavior: "smooth"})} 
                  fontSize="0.8em" 
                  className="backtop"
                >
                  <Icon as={FaArrowCircleUp} fontSize="1xl" mr="5px" /> Back to Top
                </Link>
            </Box>
          )}
          {!isVisible && (
            <Link onClick={() => window.scrollTo({top: 0, left: 0, behavior: "smooth"})} fontSize="0.8em" className="backtop" zIndex={1200}><Icon as={FaArrowCircleUp} fontSize="1xl" mr="5px" /> Back to Top</Link>
          )}
          </Box>
      </Container>
      <Box className="copyright" bg="#143B49" marginBottom="-1px">
        <Center>
          <Text textAlign="center" fontSize={'sm'} p={5} color="#E6DFD3" textTransform="uppercase">
            © {year} {variables.organization} | <Box as="br" display={{ base: "block", md: "none" }} /> Design & Development by <Link href="https://3twenty9.com" target="_blank" ml={1} _hover={{ color: 'white' }}>3twenty9 Design</Link>
          </Text>
        </Center>
      </Box>
    </Box>
  );
};

export default Footer;
